import __request__ from "routing/request";
export function list() {
  return __request__("GET", "/authz/capabilities", null, {}, {
    "Accept": ["application/json"]
  });
}
export function get(capability) {
  return __request__("GET", `/authz/capabilities/${capability}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function entityCapabilityPermissions(capability, entity) {
  return __request__("GET", `/authz/capabilities/${capability}/${entity}`, null, {}, {
    "Accept": ["application/json"]
  });
}
